var text = {
    MuiTypography: {
        defaultProps: {
            color: 'text.secondary'
        }
    }
};
export default text;
